import React, { Component } from 'react';
import { connect } from 'react-redux';

import Card from '../../common/Card';
import AuthForm from '../AuthForm';
import { loginUser } from '../../../store/auth/actions';
import { getErrorMessage, userNeedsToRevalidate } from '../../../store/auth/reducer';
import { resetPassword } from '../../../utils/dev-prod';
import './auth-page.css';

class AuthPage extends Component {
	componentDidMount() {
		document.body.classList.add('login-screen');
	}

	componentWillUnmount() {
		document.body.classList.remove('login-screen');
	}
	

	render() {
		const { loginUser, errorMessage, revalidate } = this.props;

		return (
			<div className="auth-page">
				<div className="auth-page__content">
					<Card className="auth-page__card">
						<h1 className="auth-page__title">Dale Operating Company</h1>
						{ revalidate && 
							<Card 
								color="success" 
								shadow={false}>
								<span>Your settings have been updated.<br /> Please login to continue.</span>
							</Card>
						}
						<AuthForm 
							onSubmit={values => loginUser(values)}
							errorMessage={errorMessage} />
						<a href={resetPassword} className="auth-page__forgot">Forgot Password?</a>
					</Card>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		errorMessage: getErrorMessage(state.auth),
		revalidate: userNeedsToRevalidate(state.auth),
	}
}

export default connect(mapStateToProps, { loginUser })(AuthPage);


// WEBPACK FOOTER //
// ./src/components/auth/AuthPage/index.js